module.exports = __webpack_public_path__ + "img/pvc_expomoda_0010_white.82f9f7a1.jpg";